import { searchForm, citizenshipEntity } from 'shared';

export const isInternationalCity = (
  city: searchForm.RouteState['dep'] | undefined,
) => {
  return city && city.country.code !== citizenshipEntity.config.KAZAKHSTAN_CODE;
};
